import { useEffect, useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { API_BASE } from "../../config/apiConfig";

export default function AttendLanding() {
  const [params] = useSearchParams();
  const [msg, setMsg] = useState("Verifying...");
  const [success, setSuccess] = useState(false);
  const [countdown, setCountdown] = useState(3);
  const navigate = useNavigate();

  const user = useSelector((state) => state.user.user);
  const token = sessionStorage.getItem("access_token");

  const userLoading = user === undefined;   // only wait when undefined, not null

  useEffect(() => {
    (async () => {
      // -------------------------------
      // Wait until Redux user finishes loading
      // -------------------------------
      if (userLoading) return;

      let eventId = params.get("event");
      let tk = params.get("tk");

      const stored = sessionStorage.getItem("qr_redirect");
      if (stored) {
        const url = new URL(stored, window.location.origin);
        eventId = url.searchParams.get("event");
        tk = url.searchParams.get("tk");
      }

      if (!eventId || !tk) {
        setMsg("Invalid QR code.");
        setSuccess(true);
        return;
      }

      const redirectUrl = `/attend?event=${encodeURIComponent(eventId)}&tk=${encodeURIComponent(tk)}`;

      // -------------------------------
      // Not logged in
      // -------------------------------
      if (!user || !token) {
        sessionStorage.setItem("qr_redirect", redirectUrl);
        navigate("/login", { replace: true });
        return;
      }

      // -------------------------------
      // Redeem
      // -------------------------------
      try {
        const r = await fetch(`${API_BASE}/api/attendance/redeem`, {
          method: "POST",
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ eventId, tk }),
        });

        const data = await r.json();

        if (!data.success) {
          setMsg(data.message || "Check-in failed");
        } else {
          setMsg(data.message); // Will show "Already recorded" or "Attendance recorded"
        }
      } catch (e) {
        setMsg("Check-in failed: " + e.message);
      } finally {
        sessionStorage.removeItem("qr_redirect");
        setSuccess(true);
      }

    })();
  }, [params, user, userLoading, navigate, token]);

  // Countdown Redirect
  useEffect(() => {
    if (success && countdown > 0) {
      const t = setTimeout(() => setCountdown((n) => n - 1), 1000);
      return () => clearTimeout(t);
    }
    if (success && countdown === 0) {
      navigate("/dashboard");
    }
  }, [success, countdown, navigate]);

  return (
    <div className="flex flex-col items-center justify-center text-center">
      <p className="text-lg font-semibold">{msg}</p>

      {success && (
        <>
          <button
            onClick={() => navigate("/dashboard")}
            className="mt-4 px-6 py-2 bg-blue-600 text-white rounded hover:bg-blue-700 transition"
          >
            Go to Home Page
          </button>
          <p className="mt-2 text-gray-600">
            Redirecting automatically in {countdown} second{countdown !== 1 && "s"}...
          </p>
        </>
      )}
    </div>
  );
}
